export const dataSolutionsCards = [
  {
    id: 1,
    icon: "target",
    title: "Target Audience Segmentation",
    text: "Build high-quality audience relationships with executives and administrative business leaders using validated lists.",
  },
  {
    id: 2,
    icon: "activity",
    title: "Real-Time Analytics",
    text: "Track engagement and campaign performance as it happens, not days later in a static report.",
  },
  {
    id: 3,
    icon: "lightbulb",
    title: "Actionable Insights",
    text: "Translate raw signals into next steps your sales and marketing teams can act on the same day.",
  },
];

export const dataSolutionsStats = [
  { id: 1, value: 250, suffix: "M+", label: "Verified records" },
  { id: 2, value: 85, suffix: "%", label: "Data accuracy" },
  { id: 3, value: 40, suffix: "+", label: "Industries covered" },
];
